import { Box, BoxProps } from "@chakra-ui/react";

interface DownloadIconProps extends BoxProps {
  color?: string;
}

export function DownloadIcon({
  color = "#676879",
  ...props
}: DownloadIconProps) {
  return (
    <Box {...props}>
      <svg
        width="16"
        height="13"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="elements">
          <path
            id="Vector"
            d="M8.00033 9.58333L8.00033 1.25M8.00033 9.58333C7.4168 9.58333 6.3266 7.92142 5.91699 7.5M8.00033 9.58333C8.58385 9.58333 9.67405 7.92142 10.0837 7.5"
            stroke={color}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            id="Vector 7173"
            d="M14.6668 11.25C14.6668 13.3183 14.2352 13.75 12.1668 13.75H3.8335C1.76516 13.75 1.3335 13.3183 1.3335 11.25"
            stroke={color}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </svg>
    </Box>
  );
}
